import { generateClient } from "aws-amplify/api";
import {
  getSubscriptionByName,
  getSubscriptionPlans,
  getSubscriptionByStatus,
} from "../graphql/queries";
import { manageReport } from "../graphql/mutations";

const client = generateClient();

const subscriptionService = {
  getSubscriptionByName: async (name) => {
    const response = await client.graphql({
      query: getSubscriptionByName,
      authMode: "apiKey",
      variables: {
        name: name,
      },
    });
    return response.data?.getSubscriptionByName?.items[0];
  },

  getSubscriptionPlan: async (planId) => {
    const response = await client.graphql({
      query: getSubscriptionPlans,
      authMode: "apiKey",
      variables: {
        planId,
      },
    });
    return response.data?.getSubscriptionPlans;
  },

  getSubscriptionsByStatus: async (status) => {
    const response = await client.graphql({
      query: getSubscriptionByStatus,
      authMode: "apiKey",
      variables: {
        status,
      },
    });
    return response.data?.getSubscriptionByStatus;
  },

  manageSubscriptionReport: async (data) => {
    const response = await client.graphql({
      query: manageReport,
      authMode: "userPool",
      variables: {
        data: JSON.stringify(data),
      },
    });
    return response.data?.manageReport;
  },
};

export default subscriptionService;
